import React from 'react';
import { SignUpContainer } from 'features/RegistrationContainer';

const TermsAndConditions = (props) => {
  return (
      <SignUpContainer {...props} initialStep={3} />
  );
};

export default TermsAndConditions;